<template>
  <v-card>
    <v-card-title>Relatório</v-card-title>
    <v-card class="list-card" elevation="0">
      <v-card-text v-if="resumoVendas.length != 0">
        <v-list>
          <template v-for="(item, i) in resumoVendas">
            <v-list-item :key="i">
              <div class="d-flex justify-space-between"></div>
              <v-list-item-content>
                <v-list-item-title v-if="item.novo_usado == 'N'"
                  >Venda de Novos</v-list-item-title
                >
                <v-list-item-title v-if="item.novo_usado == 'U'"
                  >Venda de Usados</v-list-item-title
                >
                <v-list-item-title v-if="item.status == 'P1'"
                  >Consórcio 1ª Parcela</v-list-item-title
                >
                <v-list-item-title v-if="item.status == 'P2'"
                  >Consórcio 2ª Parcela</v-list-item-title
                >
                <v-list-item-subtitle>{{ item.modelo }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content class="comissao">
                <span>Comissão</span>
                <span v-if="hiddenValue" style="font-weight: bold">{{
                  item.total_comissao | BrazilianCurrency
                }}</span>
                <div style="display: flex; justify-content: end" v-else>
                  <div class="space-value"></div>
                </div>
                <span>{{ item.data_venda | BrazilianStandardDate }}</span>
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="`${i}-divider`"></v-divider>
          </template>
        </v-list>
      </v-card-text>
      <v-card-text v-else>
        <p class="text-center">
          Não há dados para serem apresentados
        </p>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import currencyMixin from "@/mixins/currencyMixin";
import dateMixin from "@/mixins/dateMixin";
export default {
  name: "CardReceita",

  mixins: [currencyMixin, dateMixin],

  props: {
    resumoVendas: {
      type: Array
    },
    hiddenValue: {
      type: Boolean
    }
  },

  data() {
    return {};
  }
};
</script>

<style scoped>
.list-card {
  min-height: 350px !important;
  max-height: 350px !important;
  overflow-y: scroll !important;
}

.comissao {
  text-align: right;
  font-size: 0.8rem;
}

.space-value {
  background-color: #e4e4e4;
  width: 65px;
  height: 14px;
}

/* Works on Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: rgb(15, 42, 73);
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 3px;
}

*::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0);
}

*::-webkit-scrollbar-thumb {
  background-color: rgb(15, 42, 73, 0.3);
  border-radius: 20px;
}
</style>
